module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
    }],
    staticClass: "create-btn",
    attrs: {
      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
    },
    on: {
      "click": _vm.setShowModal
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n  ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.showModal) ? _c('AppModal', {
    attrs: {
      "modalResponsive": true,
      "isShowFooter": true,
      "modalFlexContainer": _vm.isShowSalaryInfoBox || false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.create_absence')))]), _vm._v(" "), _c('div', {
    staticClass: "create-absence__form create-absence__form--flex",
    class: {
      'create-absence__form--flex--opus-info-box': _vm.isShowSalaryInfoBox
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "create-absence__form-group-container__left"
  }, [_c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.who')))]), _vm._v(" "), _c('SubsCreateDSelect', {
    attrs: {
      "id": "create_absence_user",
      "items": _vm.users
    },
    on: {
      "update": _vm.setUsers
    }
  }), _vm._v(" "), (_vm.isAdditionalDataRequired && _vm.usersAbsent.length > 1) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n              Der kan ikke oprettes fravær for flere medarbejdere på én gang, da denne årsag kræver ekstra information.\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isUserSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.person_must_be_filled')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "create__form-group__flex-container"
  }, [_c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
    staticClass: "absence-reason"
  }, [_c('dSelect', {
    attrs: {
      "items": _vm.subsAbsenceReasonsSorted,
      "receiveData": _vm.reasonCreated,
      "multiple": false,
      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason'),
      "itemSpaceBetween": true
    },
    on: {
      "update": _vm.setReason,
      "searchText": _vm.setReasonSearchText,
      "onSearchTextDebounced": _vm.onSearchTextDebounced,
      "enter": function($event) {
        _vm.isCreateAbsenceReason = true
      },
      "close": _vm.onCloseDSelectAbsenceReasons
    },
    scopedSlots: _vm._u([(_vm.isAbsenceIntegrationActive) ? {
      key: "item-badge",
      fn: function(ref) {
        var item = ref.item;

        return [(item.kmd_absence_code_id) ? _c('span', {
          staticClass: "do-opus-badge"
        }, [_vm._v("OPUS")]) : _vm._e(), _vm._v(" "), (item.sd_absence_code_id) ? _c('span', {
          staticClass: "do-sd-badge"
        }, [_vm._v("SD")]) : _vm._e()]
      }
    } : null], null, true)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [(_vm.userHasPermission('can_manage_absence_reasons')) ? _c('h4', {
    staticClass: "create-absence-link",
    on: {
      "click": function($event) {
        _vm.isCreateAbsenceReason = true
      }
    }
  }, [_vm._v("\n                      + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.reasonSearchText) + "\"\n                    ")]) : _c('h4', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                    ")])])]), _vm._v(" "), (_vm.userHasPermission('can_manage_absence_reasons') && _vm.isShowCreateAbsenceReasonButton) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
    }],
    staticClass: "icon__bg-circle absence-reasons__settings",
    attrs: {
      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.reasonSearchText + "\" " + _vm.i18n[_vm.locale]["as_a_new_reason"]
    },
    on: {
      "click": function($event) {
        _vm.isCreateAbsenceReason = true
      }
    }
  }, [_c('span', {
    staticClass: "d-icon-plus"
  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.isReasonSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.date')))]), _vm._v(" "), _c('div', {
    staticClass: "date-picker-range-group"
  }, [_c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), (_vm.isOngoingAbsenceAllowed && !_vm.isShowSalaryInfoBox) ? _c('div', {
    staticClass: "absence-no-end-date",
    class: {
      'absence-no-end-date--active': _vm.isAbsenceOngoing
    }
  }, [_c('div', {
    staticClass: "absence-no-end-date__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOngoingAbsenceDateAllowed && !_vm.isShowSalaryInfoBox) ? _c('div', {
    staticClass: "absence-no-end-date"
  }, [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.cant_be_ongoing_absence')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.isAbsenceOnlyOnWeekend) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['absence_only_on_weekend']))]) : _vm._e(), _vm._v(" "), (_vm.absentUsersWithOngoingAbsenceAlready.length > 0) ? _c('div', {
    staticClass: "do-warning marg-1-top"
  }, [_vm._l((_vm.absentUsersWithOngoingAbsenceAlready), function(user) {
    return _c('b', {
      key: user,
      staticClass: "marg-05-right"
    }, [_vm._v(_vm._s(user) + " ")])
  }), _vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['already_has_ongoing_absence']) + "\n            ")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['set_default_start_and_endtime']
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle time-changer__settings",
    on: {
      "click": function($event) {
        _vm.isShowSettings = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-cog2"
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "create__form-group create__form-group__note-to-absence"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note_to_absence']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteForAbsentReason),
      expression: "noteForAbsentReason"
    }],
    staticClass: "d-input",
    domProps: {
      "value": (_vm.noteForAbsentReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteForAbsentReason = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isShowSalaryInfoBox) ? _c('div', {
    staticClass: "create-absence__form-group-container__right"
  }, [(!_vm.isLoadedSalarySystemInfo) ? _c('div', {
    staticClass: "create-absence__salary-system-info-container"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowSdInfoBox) ? _c('div', {
    staticClass: "create-absence__salary-system-info"
  }, [_c('div', {
    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("SD")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "users-employment-selection"
  }, [_vm._l((_vm.usersAbsent), function(userCalendarId) {
    return _c('div', {
      key: userCalendarId,
      staticClass: "marg-1-bottom"
    }, [(_vm.usersAbsent.length > 1) ? _c('label', {
      staticClass: "d-label marg-025-bottom"
    }, [_vm._v(_vm._s(_vm.getUserName(userCalendarId)))]) : _vm._e(), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedEmploymentIds[userCalendarId]),
        expression: "selectedEmploymentIds[userCalendarId]"
      }],
      staticClass: "do-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedEmploymentIds, userCalendarId, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onEmploymentChange(userCalendarId, $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.getUserEmployments(userCalendarId)), function(employment) {
      return _c('option', {
        key: employment.id,
        domProps: {
          "value": employment.id
        }
      }, [_vm._v("\n                      " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                    ")])
    })], 2)])
  }), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                  Ansættelsesnummer skal vælges for alle medarbejdere\n                ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getSDAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n                  " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__date-text"
  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " - Åbenstående")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    },
    on: {
      "toggled": function($event) {
        _vm.useTime = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowOpusInfoBox) ? _c('div', {
    staticClass: "create-absence__salary-system-info"
  }, [_c('div', {
    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("Opus")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "users-employment-selection"
  }, [_vm._l((_vm.usersAbsent), function(userCalendarId) {
    return _c('div', {
      key: userCalendarId,
      staticClass: "marg-1-bottom"
    }, [(_vm.usersAbsent.length > 1) ? _c('label', {
      staticClass: "d-label marg-025-bottom"
    }, [_vm._v(_vm._s(_vm.getUserName(userCalendarId)))]) : _vm._e(), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedEmploymentIds[userCalendarId]),
        expression: "selectedEmploymentIds[userCalendarId]"
      }],
      staticClass: "do-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedEmploymentIds, userCalendarId, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onEmploymentChange(userCalendarId, $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.getUserEmployments(userCalendarId)), function(employment) {
      return _c('option', {
        key: employment.id,
        domProps: {
          "value": employment.id
        }
      }, [_vm._v("\n                      " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                    ")])
    })], 2)])
  }), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                  Ansættelsesnummer skal vælges for alle medarbejdere\n                ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getOPUSAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n                  " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
    staticClass: "opus-info__extra-info"
  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.MaternityCaseKey,
      domProps: {
        "value": option.MaternityCaseKey
      }
    }, [_vm._v("\n                      " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ReasonCode,
      domProps: {
        "value": option.ReasonCode
      }
    }, [_vm._v("\n                      " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.AccidentNumber,
      domProps: {
        "value": option.AccidentNumber
      }
    }, [_vm._v("\n                      " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ChildNumber,
      domProps: {
        "value": option.ChildNumber
      }
    }, [_vm._v("\n                      " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen barn tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isAdditionalDataSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                    " + _vm._s(_vm.additionalDataValidationError) + "\n                  ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__date-text"
  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " →")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOpusAllowOpen) ? _c('p', {
    staticClass: "opus-info__note--muted"
  }, [_vm._v("\n                Åbenstående fravær er ikke muligt for denne fraværsårsag\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    },
    on: {
      "toggled": function($event) {
        _vm.useTime = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'top',
        zIndex: 12312312312312
      }),
      expression: "{\n                  placement : 'top',\n                  zIndex: 12312312312312  \n                }"
    }],
    staticClass: "bttn create-btn right marg-10",
    attrs: {
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.submitUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n        ")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
    on: {
      "close": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_setting']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('label', {
    staticClass: "d-input marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['set_default_start_and_endtime']))]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('TimeChanger', {
    staticClass: "marg-1-top",
    attrs: {
      "showIcon": true,
      "start": _vm.standardStartTime,
      "end": _vm.standardEndTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStandardStartTime,
      "updateEnd": _vm.setStandardEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-1-right",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submitStandardSettings
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
    attrs: {
      "initTitle": _vm.reasonSearchText
    },
    on: {
      "create": _vm.createAbsenceReason,
      "cancel": function($event) {
        _vm.isCreateAbsenceReason = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea006af8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsCreate.vue
// module id = 2152
// module chunks = 1